var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kefu"},[_c('div',{staticClass:"kefu_box"},[_c('iframe',{attrs:{"id":"kefIframe","src":_vm.qiyuUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }